import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { Divider } from "@omni/ui/components/Divider/divider.component";
import { cn } from "@omni/utils/styles";
import { FC, Fragment } from "react";

import { Row } from "@/components/General/Grid/row.component";
import { TooltipType } from "@/components/General/Tooltip/tooltip.types";
import { OrderItemModel } from "@/redux/modules/api/data/orderDetail/@types/orderItem.model";

import {
    DeliveryPromiseComponentProps,
    OrderItem
} from "../OrderItem/orderItem.component";

type ProductCollectionBlockComponentProps = {
    icon: string;
    title: string;
    products: OrderItemModel[];
    deliveryType: DeliveryType;
    additionalServiceTooltip?: TooltipType;
    productTitleLink: boolean;
    DeliveryPromiseComponent: FC<DeliveryPromiseComponentProps>;
};

const ProductCollectionBlockComponent = ({
    icon,
    title,
    products,
    deliveryType,
    additionalServiceTooltip,
    productTitleLink,
    DeliveryPromiseComponent
}: ProductCollectionBlockComponentProps) => (
    <>
        <Row className={cn("tw:bg-[#F7F7F7] tw:py-2 tw:px-4")}>
            <i className={cn("tw:mr-2 tw:text-xl", `las ${icon}`)} />
            <h5 className={cn("tw:font-bold tw:p-0 tw:m-0 tw:text-xl")}>
                {title}
            </h5>
        </Row>
        {products.map((product, index) => (
            <Fragment key={`${title}-${index}`}>
                {index > 0 && <Divider marginTop="0" />}
                <OrderItem
                    item={product}
                    deliveryType={deliveryType}
                    additionalServiceTooltip={additionalServiceTooltip}
                    productTitleLink={productTitleLink}
                    DeliveryPromiseComponent={DeliveryPromiseComponent}
                />
            </Fragment>
        ))}
    </>
);

export { ProductCollectionBlockComponent };
